import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import message from "@/components/message";
import loading from "@/components/loading";
import './assets/styles/reset.less'
import './assets/styles/media.less'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

import delayExit from '@/libs/delayExit'
Vue.use(delayExit)

//提示消息组件
Vue.prototype.$message = message;
Vue.use(loading);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js